module.exports = __webpack_public_path__ + "media/images/landing/illust/iphone-holder-6ccad714333c812c55775794c03c8945.png";